/** Minimum time the loading state is shown so the indicator is visible. */
export const SUBMIT_MIN_LOADING_MS = 500;

/** Time the success message stays visible before navigating away. */
export const SUCCESS_THEN_REDIRECT_MS = 1800;

export function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * Runs an async (or sync) function and waits until at least `minMs` has passed since `startedAt`.
 * Call with startedAt = Date.now() right before await work().
 */
export async function waitUntilMinElapsed(startedAt, minMs = SUBMIT_MIN_LOADING_MS) {
  const elapsed = Date.now() - startedAt;
  if (elapsed < minMs) await sleep(minMs - elapsed);
}
